export default __webpack_public_path__ + "static/media/KZ.Т.12.2498 black.728689cd.svg";